import React, { useRef, useEffect } from 'react';

/**
 * LiveTranscriptPane — Displays real-time speech turns during an active call.
 */
export default function LiveTranscriptPane({ turns = [], active = false, fading = false }) {
  const scrollRef = useRef(null);
  useEffect(() => {
    const el = scrollRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [turns.length]);

  return (
    <div className={`rounded-xl border border-civix-border/60 bg-civix-panelLight/60 p-2 transition-opacity duration-700 ${fading ? 'opacity-40' : 'opacity-100'}`}>
      <div className="flex items-center justify-between px-1 pb-1.5">
        <div className="text-[10px] uppercase tracking-wider text-white/50 font-semibold">
          Live transcript <span className="text-civix-purpleSoft normal-case">(beta)</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className={`w-1.5 h-1.5 rounded-full ${active ? 'bg-emerald-400 animate-pulse' : 'bg-white/20'}`} />
          <span className="text-[10px] text-white/40">{active ? 'AI listening' : 'idle'}</span>
        </div>
      </div>
      <div
        ref={scrollRef}
        className="max-h-44 overflow-y-auto space-y-1 pr-1"
        style={{ scrollbarWidth: 'thin' }}
      >
        {turns.length === 0 ? (
          <div className="text-center py-6 text-white/30 text-xs italic">
            Waiting for caller to speak…
          </div>
        ) : (
          turns.map((t, idx) => {
            const isAgent = t.speaker === 'agent';
            return (
              <div
                key={`${t.ts}-${idx}`}
                className={`flex flex-col ${isAgent ? 'items-end' : 'items-start'}`}
              >
                <span className="text-[9px] text-white/30 px-1">
                  {isAgent ? 'You' : 'Prospect'}
                </span>
                <div
                  className={`max-w-[85%] rounded-lg px-2.5 py-1 text-xs leading-relaxed ${
                    isAgent
                      ? 'bg-civix-purple/30 text-white border border-civix-purple/40'
                      : 'bg-white/5 text-white/90 border border-white/10'
                  }`}
                >
                  {t.text}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
